import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {speedTestAdsAuditDomainConfig_template} from "../components/templates/speedTestAdsAuditDomainConfig_template";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class speedTestAdsAuditDomainConfig extends vnModule_knockoutJS{

    public XHRHdl: XMLHttpRequestHandler;
    protected speedTestAdsAuditDomainConfig: speedTestAdsAuditDomainConfig_template;
    protected pagination: pagination_template;

    protected getModuleName(){
        return "speedTestAdsAuditDomainConfig";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        // create the users list
        this.speedTestAdsAuditDomainConfig = new speedTestAdsAuditDomainConfig_template("speedTestAdsAuditDomainConfig", this.viewModel, this);

        return [this.speedTestAdsAuditDomainConfig.build()];
    }

    public fillPage() : void {

        this.getListFormData();
    }

    public getListFormData(): void{

        let usrReq_url: string = '/api/speedTest/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetListFormData;
        this.XHRHdl.execute();
    }

    protected onGetListFormData(req, obj){

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if(  req.request.status == 200  ){

                    obj.updateFilters(responseParsed);
                    obj.getListData();
                }
            });
        }
    }

    protected updateFilters(responseParsed: any){

        this.speedTestAdsAuditDomainConfig.setStatusFilterItems(responseParsed.statuses);
        this.speedTestAdsAuditDomainConfig.setDomainFilterItems(responseParsed.domainsAdsAudit);
    }

    protected editDomainConfig(idDomain){

        page('/speed_test/config_ads_audit/edit/'+idDomain);
    }

    protected addDomainConfig(): void {

        page('/speed_test/config_ads_audit/add');
    }

    protected paginationOnPageClick(): void {

        this.getListData();
    }

    public listReorder(): void {

        this.getListData();
    }

    protected filterSimpleOnChange(): void {

        this.speedTestAdsAuditDomainConfig.resetPageNumber();
        this.getListData();
    }

    protected filterSimpleCancel(): void {

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.getListData();
    }

    protected getListData(): void {

        if (this.XHRHdl) {

            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.speedTestAdsAuditDomainConfig.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/speedTest/configAdsAudit/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.speedTestAdsAuditDomainConfig.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onDataRequestReturn(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateList(responseParsed);
                }
            });
            obj.loadingOut(obj.speedTestAdsAuditDomainConfig.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any): void {

        this.speedTestAdsAuditDomainConfig.setDomainConfigs(responseParsed.data);

        // update the paginator
        this.speedTestAdsAuditDomainConfig.setPaginationTotalCount(responseParsed.totalCount);
    }

    public dataReorder(id) {

        this.getListData();
    }

    protected filterDropdownOnChange(): void {

        this.getListData();
    }

    protected deleteConfig(): void {

        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON(this.speedTestAdsAuditDomainConfig.getViewModelForRequest())] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/speedTest/configAdsAudit/delete', formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onDeleteReturn;
        XHRHdl.execute();
    }

    protected onDeleteReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Domain configuration deleted successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.getListData();
            });
        }
    }

    protected activateConfig(idDomain): void {

        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON({idDomain: idDomain})] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/speedTest/configAdsAudit/activate', formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onActivateReturn;
        XHRHdl.execute();
    }

    protected onActivateReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Domain configuration activated successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.getListData();
            });
        }
    }

    protected deactivateConfig(idDomain): void {

        let formReq_params: Array<Array<string>> = [];
        formReq_params.push(["data", ko.toJSON({idDomain: idDomain})] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/speedTest/configAdsAudit/deactivate', formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onDeactivateReturn;
        XHRHdl.execute();
    }

    protected onDeactivateReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Domain configuration deactivated successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.getListData();
            });
        }
    }

    protected cancel(){

        page.redirect('/speed_test/');
    }

    protected log(idDomain){

        page.redirect('/speed_test/config_ads_audit/log/' + idDomain);
    }
}


// WEBPACK FOOTER //
// ./js/modules/speedTestAdsAuditDomainConfig.ts